<script>
  import { page } from '@inertiajs/svelte';
  import { nextInkSeed } from '../lib/ink.js';

  let flash = $derived(page.props.flash || {});

  const noticeSeed = nextInkSeed();
  const alertSeed = nextInkSeed();
</script>

<!-- .ink-frame borders follow currentColor, so the text utility tints the
     stamped frame to match. Notices get soft deckle corners; alerts read as
     torn from the page. -->
{#if flash.notice}
  <div role="alert" data-augmented-ui="tl-deckle br-deckle" data-ink-seed={noticeSeed} style="--aug-tl: 16px; --aug-br: 16px" class="ink-frame bg-accent-50/60 text-accent-800 px-4 py-3 mb-6">
    {flash.notice}
  </div>
{/if}
{#if flash.alert}
  <div role="alert" data-augmented-ui="tl-tear br-tear" data-ink-seed={alertSeed} style="--aug-tl: 16px; --aug-br: 16px" class="ink-frame bg-red-50/60 text-red-800 px-4 py-3 mb-6">
    {flash.alert}
  </div>
{/if}
